module.exports = __webpack_public_path__ + "static/img/illustration-login.4b77144d.svg";